import {Route} from "@angular/router";
import {guardUsersWatch} from "@/app/routes/guards/users-guard";

const NAME = 'Пользователи'

export const users: Route[] = [
    {
        path: 'users',
        loadComponent: () => import('@components/sportexam-users/sportexam-users.component').then(c => c.SportexamUsersComponent),
        canActivate:[guardUsersWatch],
        data: {
            breadcrumbs: [
                {name: 'Администрирование', url: '/'},
                {name: NAME, url: null},
            ],
            title: NAME,
            reuse: true,
            searchString: true
        },
    },
    {
        path: 'users/:id',
        loadComponent: () => import('@components/sportexam-users/create-user/create-user.component').then(c => c.CreateUserComponent),
        canActivate:[guardUsersWatch],
        data: {
            breadcrumbs: [
                {name: 'Администрирование', url: '/'},
                {name: NAME, url: '/users/'},
            ],
        },

    },
]
